export enum ClientAppEnum {
  None = 0,
  TradingPlatform = 1,
  WebTrader = 2,
  WebAdmin = 3,
  Android = 4,
  IOS = 5,
}
